import { render, staticRenderFns } from "./AddLoadStudent.vue?vue&type=template&id=1b70868d"
import script from "./AddLoadStudent.vue?vue&type=script&lang=js"
export * from "./AddLoadStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports